/* src/app/pages/ui-kit/components/menu-view/menu-view.component.scss */
.flex-cont {
  display: flex;
}
/*# sourceMappingURL=menu-view.component.css.map */
